import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button, Card, Text } from "@andrum/ui";
import type { PaywallReason } from "@/features/subscription/api/billing-api";

type Props = {
  title?: string;
  description?: string;
  compact?: boolean;
  /** Contextual paywall reason for tailored copy */
  reason?: PaywallReason;
};

/**
 * Soft upsell card for premium features. Never blocks free core path.
 */
export function PremiumGateCard({
  title,
  description,
  compact = false,
  reason = "default",
}: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card className={compact ? "space-y-2" : "space-y-3"}>
      <Text variant={compact ? "body" : "heading"} as={compact ? "p" : "h2"}>
        {title ?? t("premium.defaultTitle")}
      </Text>
      <Text variant="subtle" className="leading-relaxed">
        {description ?? t("premium.defaultBody")}
      </Text>
      <Button
        fullWidth
        variant="soft"
        onClick={() =>
          void navigate({
            to: "/app/paywall",
            search: { reason },
          })
        }
      >
        {t("premium.seePlus")}
      </Button>
    </Card>
  );
}
